import './InfoTable.css'
import { ReactNode, useContext } from 'react'
import { formatDate, snakeToTitle } from '../utils'
import { PreferencesContext } from './PreferencesContext'
import clsx from 'clsx'

interface InfoTableProps {
    rows: Record<string, ReactNode>
    direction?: 'horizontal' | 'vertical'
    size?: 'small' | 'regular'
    headers?: boolean
}

export function InfoTable({ rows, direction = 'vertical', size = 'regular', headers = true }: InfoTableProps) {
    const [preferences] = useContext(PreferencesContext)
    return (
        <div className={clsx('ui-info-table', direction, size, !headers && 'no-headers')}>
            {Object.keys(rows).map(item => {
                let value = rows[item]
                if (typeof value === 'boolean') {
                    value = value ? 'Yes' : 'No'
                } else if (
                    (
                        item.toLowerCase().endsWith(' at')
                        || item.toLowerCase().endsWith('_at')
                    )
                    && (typeof value === 'string' || typeof value === 'number')
                ) {
                    try {
                        value = formatDate(preferences, value, 'Pp')
                    } catch {}
                } else if (!value) {
                    value = <>&#8211;</>
                }

                return (
                    <div className="info-row" key={item}>
                        {headers && <span className="info-label">{snakeToTitle(item)}</span>}
                        <span className="info-value">{value}</span>
                    </div>
                )
            })}
        </div>
    )
}
